import React from "react";
import StandardCard from "../../common/StandardCard.jsx";
import "../../../assets/styles/secoundaryCard.scss";

export default function RolesCardView({
  data,
  setAddNewRole,
  headerClass,
  ...props
}) {
  return (
    <React.Fragment>
      <div className={`card-container mt-3 ${headerClass}`}>
        {data?.map((item) =>
            <StandardCard
              key={item?.app_role_id}
              userCount={item?.users.length}
              avatars={item?.avatar}
              title={item?.title}
              onClick={props?.onClick}
              item={item}
            />
        )}
        <div className="card-item-std p-4 bg-white primary-box-shadow border-round-md">
          <button
            className="bg-primarySuccessButtonColor font-medium text-15px border-round-lg p-button p-component mt-3 md:mt-0"
            onClick={() => setAddNewRole(true)}
          >
            Add New Role
          </button>
          <p className="text-primaryColor public_sans_400 text-15px mb-0">
            Add new role,
          </p>
          <p className="text-primaryColor public_sans_400 text-15px mt-1 mb-0">
            if it doesn't exist.
          </p>
        </div>
      </div>
    </React.Fragment>
  );
}
